// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"258":"e808d995","471":"5e07a06a","729":"3fb99aaa","805":"1e5aa218"}[chunkId] + ".chunk.css";
};